module.exports = __webpack_public_path__ + "static/media/img4.5c131234.jpg";